import React from 'react';
import { useHistory } from 'react-router-dom';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { useStyletron } from 'baseui';

import usePermissionV2 from 'commons-ui/src/permission/usePermission';
import { BULK_ACTIONS_RESOURCES, PAGE_NAMES } from 'constant';
import { Card } from 'commons-ui';

import { URL, LABEL, IMAGE_SOURCE } from './helper';

const useSettingsHome = () => {
	const { hasPermission: hasPermissionV2 } = usePermissionV2();

	const isEnabled = (configResourceName: string) => {
		return hasPermissionV2({
			configPageName: PAGE_NAMES.bulkActions,
			configResourceName
		});
	};

	return { isEnabled };
};

const BulkActionsHome: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { isEnabled } = useSettingsHome();

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-evenly',
				alignItems: 'center',
				height: '100%'
			})}>
			{_map(_keys(BULK_ACTIONS_RESOURCES), (resourceName) => {
				return isEnabled(resourceName) ? (
					<div
						key={resourceName}
						className={css({
							height: '130px',
							width: '40%',
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-around'
						})}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[resourceName]);
						}}>
						<Card label={LABEL[resourceName]} img={IMAGE_SOURCE[resourceName]} />
					</div>
				) : null;
			})}
		</div>
	);
};

export default BulkActionsHome;
